import get from "lodash/get"

const styles = theme => ({
    background: {
        position: "absolute",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        "z-index": -1,
    },
    overlay: {
        position: "absolute",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        zIndex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.4)', // Add a semi-transparent black overlay
      },
    primary: {
        width: "100%",
        height: "100%",
        transition: "background-image 0.5s ease-in-out",
        "background-image": `radial-gradient(circle at 100% 100%, ${get(theme, "appicalTheme.loginBg2")}, ${get(theme, "appicalTheme.loginBg1")})`,
    },

    resetPassword: {
        extend: "primary",
        "background-image": `radial-gradient(circle at 100% 100%, ${get(theme, "appicalTheme.resetPasswordBg2")}, ${get(theme, "appicalTheme.resetPasswordBg1")})`,
    },

    image: {
        position: "absolute",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        opacity: get(theme, "appicalTheme.loginBackgroundImageOpacity"),
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundImage: get(theme, "appicalTheme.loginBackgroundImage"),
    },
})

export default styles
